const godUser = ({ next, from }) => {
  const isGod = localStorage.getItem('currentCompanySlug') === 'vsimple-integrations'
  if (isGod) {
    return next()
  }
  return next(from)
}

export default godUser
